import FieldModel, { POSITIVE_INTEGER } from '../../models/FieldModel';
import { getAttributeExistingObject } from '../utils/utils';

export function buildBoletoDevedor(boletoDevedor) {
  return ({

    idContaBancaria: new FieldModel({
      value: getAttributeExistingObject(boletoDevedor, 'idContaBancaria'),
    }),
    idBanco: new FieldModel({
      value: getAttributeExistingObject(boletoDevedor, 'idBanco'),
    }),
    agencia: new FieldModel({
      name: 'agencia',
      value: getAttributeExistingObject(boletoDevedor, 'agencia'),
      errorMessage: 'Campo obrigatório',
      required: true,
    }),
    numero: new FieldModel({
      name: 'numero',
      value: getAttributeExistingObject(boletoDevedor, 'numero'),
      errorMessage: 'Campo obrigatório',
      required: true,
    }),
    dac: new FieldModel({
      name: 'dac',
      value: getAttributeExistingObject(boletoDevedor, 'dac'),
      errorMessage: 'Campo obrigatório',
      required: true,
    }),
    titular: new FieldModel({
      name: 'titular',
      value: getAttributeExistingObject(boletoDevedor, 'titular'),
      errorMessage: 'Campo obrigatório',
      required: true,
    }),
    cnpjCpf: new FieldModel({
      name: 'cnpjCpf',
      value: getAttributeExistingObject(boletoDevedor, 'cnpjCpf'),
      errorMessage: 'Campo obrigatório',
      required: true,
    }),
    chavePix: new FieldModel({
      name: 'chavePix',
      value: getAttributeExistingObject(boletoDevedor, 'chavePix'),
      errorMessage: 'Campo obrigatório',
      required: true,
    }),
    idTipoContaBancaria: new FieldModel({
      name: 'idTipoContaBancaria',
      value: getAttributeExistingObject(boletoDevedor, 'idTipoContaBancaria'),
    }),
    idTipoChavePix: new FieldModel({
      name: 'idTipoChavePix',
      value: getAttributeExistingObject(boletoDevedor, 'idTipoChavePix'),
    }),
    carteira: new FieldModel({
      name: 'carteira',
      value: getAttributeExistingObject(boletoDevedor, 'carteira'),
      type: POSITIVE_INTEGER,
    }),
  });
}
